"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module parjs/internal/implementation/parsers
 */
/** */
const action_1 = require("../../action");
const reply_1 = require("../../../../reply");
class PrsStringOf extends action_1.ParjsBasicAction {
    constructor(_strs) {
        super();
        this._strs = _strs;
        this.isLoud = true;
        this.expecting = `any of ${_strs.map(x => `'${x}'`).join(", ")}`;
    }
    _apply(ps) {
        let { position, input } = ps;
        let { _strs } = this;
        strLoop: for (let i = 0; i < _strs.length; i++) {
            let curStr = _strs[i];
            if (input.length - position < curStr.length)
                continue;
            for (let j = 0; j < curStr.length; j++) {
                if (curStr.charCodeAt(j) !== input.charCodeAt(position + j)) {
                    continue strLoop;
                }
            }
            //this means we did not contiue strLoop so curStr passed our tests
            ps.position = position + curStr.length;
            ps.value = curStr;
            ps.kind = reply_1.ReplyKind.Ok;
            return;
        }
        ps.kind = reply_1.ReplyKind.SoftFail;
    }
}
exports.PrsStringOf = PrsStringOf;
//# sourceMappingURL=string-of.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/internal/implementation/parsers/string/string-of.js
// module id = 995
// module chunks = 0 1